import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type StatCardVariant = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';

@Component({
  selector: 'app-stat-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stat-card.component.html',
  styleUrl: './stat-card.component.scss'
})
export class StatCardComponent {
  @Input() title: string = '';
  @Input() value: string | number = '';
  @Input() icon?: string;
  @Input() variant: StatCardVariant = 'primary';
  @Input() trend?: number; // Positive or negative number for trend indicator
  @Input() trendLabel?: string;
  @Input() loading: boolean = false;
  @Input() subtitle?: string;

  get trendDirection(): 'up' | 'down' | 'neutral' {
    if (!this.trend) return 'neutral';
    if (this.trend > 0) return 'up';
    if (this.trend < 0) return 'down';
    return 'neutral';
  }

  get trendIconClass(): string {
    switch (this.trendDirection) {
      case 'up':
        return 'pi pi-arrow-up';
      case 'down':
        return 'pi pi-arrow-down';
      default:
        return 'pi pi-minus';
    }
  }
}
